// extracted by mini-css-extract-plugin
export default {"movieTitle":"TruncatedTitle_movieTitle__pW43O"};